import { render, staticRenderFns } from "./BlogPostElement.vue?vue&type=template&id=c4fe52d2&scoped=true&"
import script from "./BlogPostElement.vue?vue&type=script&lang=js&"
export * from "./BlogPostElement.vue?vue&type=script&lang=js&"
import style0 from "./BlogPostElement.vue?vue&type=style&index=0&id=c4fe52d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4fe52d2",
  null
  
)

export default component.exports